export class LibrarySearchSecondary {
	constructor(element) {
		this.element = element;
		if (!this.element) return;

		this.clear = this.element?.querySelector('.library-search-secondary__clear');
		this.input = this.element?.querySelector('.library-search-secondary__input');

		this.init();
	}

	clearClickHandler = () => {
		this.input.value = '';
		this.input.dispatchEvent(new Event ('input'));
	};

	init = () => {
		this.clear.addEventListener('click', this.clearClickHandler);
	};
}
